/**
 * Mega Menu — Hess Sound Desktop Navigation
 * Click-to-open/close, Hover-to-open (Desktop non-touch),
 * Staggered Backdrop Animation (Zest-Style),
 * Keyboard Navigation, Focus Trap, ARIA
 *
 * [C1-Fix] Item = <div>, Trigger = <button> (Panel als Sibling, nicht Kind)
 * [C2-Fix] Focus-Trap schliesst Trigger-Button ein
 */
(function () {
  'use strict';

  var header = document.querySelector('.hs-mega-header');
  var nav = document.querySelector('.hs-mega-nav');
  var overlay = document.querySelector('.hs-mega-backdrop__overlay');
  if (!nav || !header) return;

  var items = nav.querySelectorAll('.hs-mega-nav__item');
  var triggers = nav.querySelectorAll('.hs-mega-nav__trigger');
  var enterTimeout = null;
  var leaveTimeout = null;
  var switchTimeout = null;

  /* prefers-reduced-motion: JS-Timeouts auf 0 setzen, damit Panel-Reaktion nicht traege wirkt,
     wenn CSS-Transitions auf 0.01ms reduziert sind. Live-reactive via MediaQueryList. */
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduceMotion = motionQuery.matches;
  if (motionQuery.addEventListener) {
    motionQuery.addEventListener('change', function (e) { reduceMotion = e.matches; });
  }
  function d(ms) { return reduceMotion ? 0 : ms; }

  /* [W3] Input-Typ-Erkennung: Hover nur bei Maus, nicht bei Touch/Pen (Hybrid-Geraete-safe) */
  var lastInputType = 'mouse';
  window.addEventListener('pointerdown', function (e) { lastInputType = e.pointerType; }, { passive: true });

  // Dot-Visibility: Trennpunkt zwischen zwei Links auf unterschiedlichen Zeilen
  // ausblenden — sonst wuerde der Dot entweder am Zeilen-Ende trailing haengen
  // oder am Zeilen-Anfang wie ein Aufzaehlungspunkt wirken.
  //
  // WICHTIG: visibility:hidden statt display:none. Der Dot behaelt seine Margins,
  // damit Tags am Zeilenumbruch nicht optisch verschmelzen (z.B. "Kinder und
  // KlangKlang und Beruf" ohne Space).
  //
  // offsetTop triggert forced layout — deshalb nur im scope des aktuell offenen
  // Panels iterieren. Bei resize Scope = ganzes nav (Fallback, seltener Event).
  function updateDots(scope) {
    var root = scope || nav.querySelector('.hs-mega-nav__item.is-open') || nav;
    var containers = root.querySelectorAll('.hs-mega-shop__card-links, .hs-mega-gongs__zub, .hs-mega-wissen__tags');
    containers.forEach(function (container) {
      var dots = container.querySelectorAll('.hs-mega-dot');
      dots.forEach(function (dot) { dot.style.visibility = ''; });
      dots.forEach(function (dot) {
        var prev = dot.previousElementSibling;
        var next = dot.nextElementSibling;
        if (!prev || !next) return;
        if (prev.offsetTop !== next.offsetTop) {
          dot.style.visibility = 'hidden';
        }
      });
    });
  }

  function getTrigger(item) {
    return item.querySelector('.hs-mega-nav__trigger');
  }

  function closeAll(except) {
    items.forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      getTrigger(item).setAttribute('aria-expanded', 'false');
    });
  }

  function activateMega() {
    /* [U2] Body-Scroll-Lock, wenn Panel offen. Padding-Right kompensiert Scrollbar-Weg-Shift. */
    if (!header.classList.contains('is-mega-active')) {
      var scrollbarW = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarW > 0) {
        document.body.style.paddingRight = scrollbarW + 'px';
      }
      document.body.style.overflow = 'hidden';
    }
    header.classList.add('is-mega-active');
  }

  function deactivateMega() {
    header.classList.remove('is-mega-active');
    header.classList.remove('is-switching');
    items.forEach(function (i) { i.classList.remove('is-leaving'); });
    /* [U2] Scroll-Lock aufheben */
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function openPanel(item) {
    var panelInner = item.__panelInner;
    if (!panelInner || panelInner.children.length === 0) return;

    var currentOpen = nav.querySelector('.hs-mega-nav__item.is-open');
    var isSwitching = !!currentOpen && currentOpen !== item;

    clearTimeout(leaveTimeout);
    clearTimeout(enterTimeout);
    clearTimeout(switchTimeout);

    activateMega();

    if (isSwitching) {
      /* Panel-Switch: Cross-Fade — altes Panel blendet aus, neues ein */
      header.classList.add('is-switching');
      items.forEach(function (i) { i.classList.remove('is-leaving'); });
      currentOpen.classList.add('is-leaving');
      closeAll(item);
      panelInner.classList.add('is-entering');
      item.classList.add('is-open');
      getTrigger(item).setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () { updateDots(item); });
      switchTimeout = setTimeout(function () {
        items.forEach(function (i) { i.classList.remove('is-leaving'); });
        panelInner.classList.remove('is-entering');
        header.classList.remove('is-switching');
      }, d(350));
    } else if (!item.classList.contains('is-open')) {
      closeAll(item);
      enterTimeout = setTimeout(function () {
        item.classList.add('is-open');
        getTrigger(item).setAttribute('aria-expanded', 'true');
        requestAnimationFrame(function () { updateDots(item); });
      }, d(80));
    }
  }

  function closePanel(item) {
    clearTimeout(enterTimeout);
    item.classList.remove('is-open');
    item.classList.remove('is-leaving');
    getTrigger(item).setAttribute('aria-expanded', 'false');

    leaveTimeout = setTimeout(function () {
      if (!nav.querySelector('.hs-mega-nav__item.is-open')) {
        deactivateMega();
      }
    }, d(80));
  }

  function togglePanel(item) {
    if (item.classList.contains('is-open')) {
      closePanel(item);
    } else {
      openPanel(item);
    }
  }

  /* [C2-Fix] Focus-Trap: Tab-Navigation innerhalb Trigger + Panel halten */
  function getFocusableElements(el) {
    return el.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
  }

  function trapFocus(e, item) {
    var trigger = getTrigger(item);
    var panel = item.querySelector('.hs-mega-nav__panel');
    if (!panel) return;
    var focusable = getFocusableElements(panel);
    if (focusable.length === 0) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    /* Shift+Tab auf erstem Panel-Element -> zurueck zum Trigger */
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      trigger.focus();
    /* Tab auf Trigger -> vorwaerts ins Panel */
    } else if (!e.shiftKey && document.activeElement === trigger) {
      e.preventDefault();
      first.focus();
    /* Tab auf letztem Panel-Element -> zurueck zum Trigger */
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      trigger.focus();
    }
  }

  // Event-Delegation pro Nav-Item. Panel-Inner einmal pro Item cachen —
  // wird in Click/Hover/Keydown referenziert und aendert sich zur Laufzeit nicht.
  items.forEach(function (item) {
    var trigger = getTrigger(item);
    item.__panelInner = item.querySelector('.hs-mega-nav__panel-inner');
    var panelInner = item.__panelInner;
    var hasContent = !!(panelInner && panelInner.children.length > 0);
    if (!hasContent) return;

    // Click auf Trigger togglet Panel
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      togglePanel(item);
    });

    /* [W3] Hover-to-open fuer Desktop (Non-Touch) */
    var hoverDelay = null;
    item.addEventListener('mouseenter', function () {
      if (lastInputType === 'touch') return;
      clearTimeout(hoverDelay);
      hoverDelay = setTimeout(function () {
        openPanel(item);
      }, d(120));
    });

    item.addEventListener('mouseleave', function () {
      if (lastInputType === 'touch') return;
      clearTimeout(hoverDelay);
      hoverDelay = setTimeout(function () {
        if (!item.matches(':hover')) {
          closePanel(item);
        }
      }, d(200));
    });

    // Keyboard Navigation (Events bubblen vom Trigger/Panel zum Item)
    item.addEventListener('keydown', function (e) {
      /* Enter/Space nur auf dem Trigger — nicht auf Panel-Links */
      if ((e.key === 'Enter' || e.key === ' ') && e.target === trigger) {
        e.preventDefault();
        togglePanel(item);
        if (item.classList.contains('is-open')) {
          setTimeout(function () {
            var firstLink = panelInner.querySelector('a');
            if (firstLink) firstLink.focus();
          }, 120);
        }
      }

      /* [C2-Fix] Tab-Trap innerhalb offener Panels */
      if (e.key === 'Tab' && item.classList.contains('is-open')) {
        trapFocus(e, item);
      }
    });
  });

  // Arrow-Key Navigation zwischen Triggern (horizontal)
  nav.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var idx = Array.prototype.indexOf.call(triggers, document.activeElement);
    if (idx === -1) return;
    e.preventDefault();
    if (e.key === 'ArrowRight') {
      idx = (idx + 1) % triggers.length;
    } else {
      idx = (idx - 1 + triggers.length) % triggers.length;
    }
    triggers[idx].focus();
  });

  // Escape schliesst Mega-Menu
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var activeItem = nav.querySelector('.is-open');
      if (activeItem) {
        closePanel(activeItem);
        getTrigger(activeItem).focus();
      }
    }
  });

  // Click ausserhalb schliesst
  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target) && (!overlay || !overlay.contains(e.target))) {
      var activeItem = nav.querySelector('.is-open');
      if (activeItem) {
        closePanel(activeItem);
      }
    }
  });

  // Overlay-Klick schliesst
  if (overlay) {
    overlay.addEventListener('click', function () {
      var activeItem = nav.querySelector('.is-open');
      if (activeItem) {
        closePanel(activeItem);
      }
    });
  }

  // Progressive Enhancement: Intl.DateTimeFormat fuer Locale-korrekte Datumsformatierung
  if (typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
    var timeElements = document.querySelectorAll('.hs-mega-wissen__event time[datetime]');
    if (timeElements.length > 0) {
      var lang = document.documentElement.lang || 'de';
      var formatter = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'numeric', year: 'numeric' });
      timeElements.forEach(function (el) {
        var date = new Date(el.getAttribute('datetime') + 'T00:00:00');
        if (!isNaN(date.getTime())) {
          el.textContent = formatter.format(date);
        }
      });
    }
  }

  /* Sticky-Header: hide-on-scroll-down, show-on-scroll-up.
     Header ist position:fixed (escapes overflow:clip des Site-Wrappers).
     Placeholder haelt den Flow-Platz. Top-Offset wird dynamisch auf die sichtbare
     Resthoehe der Ancestor-Sections (Announcement-Bar etc.) gesetzt, damit die
     Bar oben sichtbar bleibt bis sie ausgescrollt ist.
     is-mega-active erzwingt Sichtbarkeit (Panel darf Trigger nicht verlieren). */
  var section = document.querySelector('.hs-mega-menu-section');
  var placeholder = document.querySelector('.hs-mega-header__placeholder');
  var lastScrollY = window.scrollY;
  var scrollTicking = false;
  var scrollThreshold = 80;
  var aboveHeight = 0;
  var headerHeight = 0;

  function measureLayout() {
    headerHeight = header.getBoundingClientRect().height;
    if (placeholder) {
      placeholder.style.height = headerHeight + 'px';
    }
    var h = 0;
    if (section) {
      var el = section.previousElementSibling;
      while (el) {
        h += el.getBoundingClientRect().height;
        el = el.previousElementSibling;
      }
    }
    aboveHeight = h;
  }

  function updateStickyHeader() {
    /* iOS/macOS Elastic-Scroll: scrollY kann negativ werden beim Overscroll nach oben.
       Clamp bei 0, damit der Header nicht mit-bounced. */
    var y = Math.max(0, window.scrollY);
    header.style.top = Math.max(0, aboveHeight - y) + 'px';
    if (header.classList.contains('is-mega-active') || y < scrollThreshold) {
      header.classList.remove('is-hidden');
    } else if (y > lastScrollY) {
      header.classList.add('is-hidden');
    } else if (y < lastScrollY) {
      header.classList.remove('is-hidden');
    }
    lastScrollY = y;
    scrollTicking = false;
  }

  window.addEventListener('scroll', function () {
    if (!scrollTicking) {
      requestAnimationFrame(updateStickyHeader);
      scrollTicking = true;
    }
  }, { passive: true });

  // Resize: Dots neu berechnen + Layout neu vermessen
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      updateDots();
      measureLayout();
      updateStickyHeader();
    }, 150);
  });

  // Initial messen + positionieren
  measureLayout();
  updateStickyHeader();
})();
